<div class="flex flex-col items-center justify-center gap-20 h-full py-20">
  <div
    class="text-6xl leading-22.5 py-10 px-8 rounded-2xl mb-[5vh] border-2 border-mib-primary text-center w-fit">
    Sorry! This page seems to be missing.
  </div>
  <mib-button>Back to home</mib-button>
</div>
